function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M339.942 305.811H410.782L416.854 330.009H333.87L339.942 305.811Z",
  fill: "#D2E1F7"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 345.002,
  y: 294.72,
  width: 60.7199,
  height: 11.0907,
  rx: 4,
  fill: "#C6D7EE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M374.774 1.6084L389.586 16.3652V294.721H387.562L387.561 17.2009L374.773 4.4607L361.986 17.2009L361.986 294.721H359.962V16.3652L374.774 1.6084Z",
  fill: "#C6D7EE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M386.4 279.597C387.006 279.597 387.584 279.859 387.986 280.317C388.721 281.154 388.686 282.411 387.936 283.206L387.804 283.335L362.956 305.543C362.518 305.934 361.849 305.893 361.461 305.451C361.103 305.043 361.11 304.436 361.457 304.038L361.551 303.942L386.4 281.734H362.254C361.669 281.734 361.194 281.256 361.194 280.666C361.194 280.118 361.603 279.666 362.13 279.604L362.254 279.597H386.4Z",
  fill: "#C6D7EE"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M386.4 255.399C387.006 255.399 387.584 255.661 387.986 256.119C388.721 256.956 388.686 258.213 387.936 259.008L387.804 259.137L362.956 281.345C362.518 281.736 361.849 281.695 361.461 281.253C361.103 280.845 361.11 280.238 361.457 279.84L361.551 279.745L386.4 257.536H362.254C361.669 257.536 361.194 257.058 361.194 256.468C361.194 255.92 361.603 255.468 362.13 255.406L362.254 255.399H386.4Z",
  fill: "#C6D7EE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M386.4 231.201C387.006 231.201 387.584 231.463 387.986 231.921C388.721 232.759 388.686 234.015 387.936 234.811L387.804 234.939L362.956 257.147C362.518 257.538 361.849 257.497 361.461 257.055C361.103 256.648 361.11 256.041 361.457 255.642L361.551 255.547L386.4 233.339H362.254C361.669 233.339 361.194 232.86 361.194 232.27C361.194 231.722 361.603 231.27 362.13 231.208L362.254 231.201H386.4Z",
  fill: "#C6D7EE"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M386.4 208.011C387.006 208.011 387.584 208.274 387.986 208.732C388.721 209.569 388.686 210.825 387.936 211.621L387.804 211.749L362.956 233.957C362.518 234.349 361.849 234.308 361.461 233.866C361.103 233.458 361.11 232.851 361.457 232.452L361.551 232.357L386.4 210.149H362.254C361.669 210.149 361.194 209.671 361.194 209.08C361.194 208.532 361.603 208.08 362.13 208.019L362.254 208.011H386.4Z",
  fill: "#C6D7EE"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M386.4 183.813C387.006 183.813 387.584 184.076 387.986 184.534C388.721 185.371 388.686 186.627 387.936 187.423L387.804 187.551L362.956 209.759C362.518 210.151 361.849 210.11 361.461 209.668C361.103 209.26 361.11 208.653 361.457 208.254L361.551 208.159L386.4 185.951H362.254C361.669 185.951 361.194 185.473 361.194 184.882C361.194 184.334 361.603 183.882 362.13 183.821L362.254 183.813H386.4Z",
  fill: "#C6D7EE"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M386.4 159.616C387.006 159.616 387.584 159.878 387.986 160.336C388.721 161.173 388.686 162.43 387.936 163.225L387.804 163.353L362.956 185.561C362.518 185.953 361.849 185.912 361.461 185.47C361.103 185.062 361.11 184.455 361.457 184.056L361.551 183.961L386.4 161.753H362.254C361.669 161.753 361.194 161.275 361.194 160.684C361.194 160.136 361.603 159.685 362.13 159.623L362.254 159.616H386.4Z",
  fill: "#C6D7EE"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M386.4 135.418C387.006 135.418 387.584 135.68 387.986 136.138C388.721 136.975 388.686 138.232 387.936 139.027L387.804 139.155L362.956 161.363C362.518 161.755 361.849 161.714 361.461 161.272C361.103 160.864 361.11 160.257 361.457 159.858L361.551 159.763L386.4 137.555H362.254C361.669 137.555 361.194 137.077 361.194 136.486C361.194 135.938 361.603 135.487 362.13 135.425L362.254 135.418H386.4Z",
  fill: "#C6D7EE"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M386.4 111.22C387.006 111.22 387.584 111.482 387.986 111.94C388.721 112.777 388.686 114.034 387.936 114.829L387.804 114.957L362.956 137.165C362.518 137.557 361.849 137.516 361.461 137.074C361.103 136.666 361.11 136.059 361.457 135.66L361.551 135.565L386.4 113.357H362.254C361.669 113.357 361.194 112.879 361.194 112.288C361.194 111.74 361.603 111.289 362.13 111.227L362.254 111.22H386.4Z",
  fill: "#C6D7EE"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M386.4 87.022C387.006 87.022 387.584 87.2842 387.986 87.7422C388.721 88.5794 388.686 89.8359 387.936 90.6314L387.804 90.7596L362.956 112.968C362.518 113.359 361.849 113.318 361.461 112.876C361.103 112.468 361.11 111.861 361.457 111.463L361.551 111.368L386.4 89.1595H362.254C361.669 89.1595 361.194 88.681 361.194 88.0907C361.194 87.5426 361.603 87.0909 362.13 87.0292L362.254 87.022H386.4Z",
  fill: "#C6D7EE"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M386.4 63.8323C387.006 63.8323 387.584 64.0945 387.986 64.5525C388.721 65.3897 388.686 66.6462 387.936 67.4417L387.804 67.5699L362.956 89.7779C362.518 90.1693 361.849 90.1284 361.461 89.6865C361.103 89.2787 361.11 88.6718 361.457 88.273L361.551 88.1779L386.4 65.9698H362.254C361.669 65.9698 361.194 65.4913 361.194 64.901C361.194 64.3529 361.603 63.9012 362.13 63.8395L362.254 63.8323H386.4Z",
  fill: "#C6D7EE"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M386.4 39.6343C387.006 39.6343 387.584 39.8965 387.986 40.3545C388.721 41.1917 388.686 42.4482 387.936 43.2437L387.804 43.3719L362.956 65.5799C362.518 65.9713 361.849 65.9304 361.461 65.4886C361.103 65.0807 361.11 64.4738 361.457 64.075L361.551 63.9799L386.4 41.7718H362.254C361.669 41.7718 361.194 41.2933 361.194 40.703C361.194 40.1549 361.603 39.7032 362.13 39.6415L362.254 39.6343H386.4Z",
  fill: "#C6D7EE"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M386.4 15.4365C387.006 15.4365 387.584 15.6987 387.986 16.1568C388.721 16.9939 388.686 18.2505 387.936 19.046L387.804 19.1741L362.956 41.3822C362.518 41.7736 361.849 41.7326 361.461 41.2908C361.103 40.8829 361.11 40.276 361.457 39.8772L361.551 39.7821L386.4 17.574H362.254C361.669 17.574 361.194 17.0955 361.194 16.5053C361.194 15.9572 361.603 15.5055 362.13 15.4437L362.254 15.4365H386.4Z",
  fill: "#C6D7EE"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M254.606 41.7055L374.98 0.5L440.661 40.7923L439.6 42.5094L374.732 2.71641L255.263 43.6126L254.606 41.7055Z",
  fill: "#C6D7EE"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M415.056 41.051C415.662 41.051 416.239 41.2825 416.641 41.6869C417.375 42.4261 417.341 43.5356 416.591 44.2379L416.46 44.3511L391.629 63.9594C391.191 64.3049 390.522 64.2688 390.135 63.8787C389.777 63.5186 389.784 62.9827 390.131 62.6306L390.225 62.5466L415.056 42.9383H390.927C390.342 42.9383 389.868 42.5158 389.868 41.9947C389.868 41.5107 390.277 41.1119 390.803 41.0574L390.927 41.051H415.056Z",
  fill: "#C6D7EE"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M440.338 41.051C440.944 41.051 441.521 41.2825 441.923 41.6869C442.657 42.4261 442.623 43.5356 441.873 44.2379L441.742 44.3511L416.911 63.9594C416.473 64.3049 415.804 64.2688 415.417 63.8787C415.059 63.5186 415.066 62.9827 415.413 62.6306L415.507 62.5466L440.338 42.9383H416.209C415.624 42.9383 415.15 42.5158 415.15 41.9947C415.15 41.5107 415.559 41.1119 416.085 41.0574L416.209 41.051H440.338Z",
  fill: "#C6D7EE"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M442.455 66.2093V41.051H414.139V66.2093H442.455ZM416.162 43.0637H440.432V64.1967H416.162V43.0637Z",
  fill: "#C6D7EE"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M416.162 66.2093V41.051H387.846V66.2093H416.162ZM389.868 43.0637H414.139V64.1967H389.868V43.0637Z",
  fill: "#C6D7EE"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M335.165 41.051C335.771 41.051 336.348 41.2825 336.75 41.6869C337.484 42.4261 337.45 43.5356 336.7 44.2379L336.569 44.3511L311.738 63.9594C311.3 64.3049 310.631 64.2688 310.243 63.8787C309.886 63.5186 309.893 62.9827 310.24 62.6306L310.334 62.5466L335.165 42.9383H311.036C310.451 42.9383 309.977 42.5158 309.977 41.9947C309.977 41.5107 310.386 41.1119 310.912 41.0574L311.036 41.051H335.165Z",
  fill: "#C6D7EE"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M360.447 41.051C361.053 41.051 361.63 41.2825 362.032 41.6869C362.766 42.4261 362.732 43.5356 361.982 44.2379L361.851 44.3511L337.02 63.9594C336.582 64.3049 335.913 64.2688 335.525 63.8787C335.168 63.5186 335.175 62.9827 335.522 62.6306L335.616 62.5466L360.447 42.9383H336.318C335.733 42.9383 335.259 42.5158 335.259 41.9947C335.259 41.5107 335.668 41.1119 336.194 41.0574L336.318 41.051H360.447Z",
  fill: "#C6D7EE"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M362.564 66.2093V41.051H334.248V66.2093H362.564ZM336.271 43.0637H360.541V64.1967H336.271V43.0637Z",
  fill: "#C6D7EE"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M336.27 66.2093V41.051H307.955V66.2093H336.27ZM309.977 43.0637H334.248V64.1967H309.977V43.0637Z",
  fill: "#C6D7EE"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M282.578 41.051C283.184 41.051 283.761 41.2825 284.163 41.6869C284.897 42.4261 284.863 43.5356 284.113 44.2379L283.982 44.3511L259.151 63.9594C258.713 64.3049 258.044 64.2688 257.657 63.8787C257.299 63.5186 257.306 62.9827 257.653 62.6306L257.747 62.5466L282.578 42.9383H258.449C257.865 42.9383 257.391 42.5158 257.391 41.9947C257.391 41.5107 257.799 41.1119 258.326 41.0574L258.449 41.051H282.578Z",
  fill: "#C6D7EE"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M307.86 41.051C308.466 41.051 309.043 41.2825 309.445 41.6869C310.179 42.4261 310.145 43.5356 309.395 44.2379L309.264 44.3511L284.433 63.9594C283.995 64.3049 283.326 64.2688 282.939 63.8787C282.581 63.5186 282.588 62.9827 282.935 62.6306L283.029 62.5466L307.86 42.9383H283.731C283.147 42.9383 282.673 42.5158 282.673 41.9947C282.673 41.5107 283.081 41.1119 283.608 41.0574L283.731 41.051H307.86Z",
  fill: "#C6D7EE"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M309.977 66.2093V41.051H281.661V66.2093H309.977ZM283.684 43.0637H307.955V64.1967H283.684V43.0637Z",
  fill: "#C6D7EE"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M283.684 66.2093V41.051H255.368V66.2093H283.684ZM257.391 43.0637H281.661V64.1967H257.391V43.0637Z",
  fill: "#C6D7EE"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M256.285 41.051C256.891 41.051 257.468 41.2825 257.87 41.6869C258.604 42.4261 258.57 43.5356 257.82 44.2379L257.689 44.3511L232.858 63.9594C232.42 64.3049 231.751 64.2688 231.364 63.8787C231.006 63.5186 231.013 62.9827 231.36 62.6306L231.454 62.5466L256.285 42.9383H232.156C231.571 42.9383 231.097 42.5158 231.097 41.9947C231.097 41.5107 231.506 41.1119 232.032 41.0574L232.156 41.051H256.285Z",
  fill: "#C6D7EE"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M205.91 66.2092C205.304 66.2092 204.727 65.9777 204.325 65.5733C203.591 64.8341 203.625 63.7247 204.375 63.0223L204.506 62.9092L229.337 43.3009C229.775 42.9553 230.444 42.9915 230.831 43.3816C231.189 43.7417 231.182 44.2776 230.835 44.6297L230.741 44.7137L205.91 64.3219H230.039C230.624 64.3219 231.097 64.7444 231.097 65.2656C231.097 65.7495 230.689 66.1484 230.162 66.2029L230.039 66.2092H205.91Z",
  fill: "#C6D7EE"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M257.391 66.2093V41.051H229.075V66.2093H257.391ZM231.097 43.0637H255.368V64.1967H231.097V43.0637Z",
  fill: "#C6D7EE"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M231.034 66.7124L231.034 106.685L231.25 106.741C236.286 108.1 238.969 111.151 239.081 115.764L239.084 116.067C239.084 121.203 236.31 123.963 231.056 124.015C225.341 123.779 222.23 121.158 222.116 116.342L222.113 116.067H224.136C224.136 119.894 226.331 121.806 231.087 122.003C235.186 121.962 237.062 120.095 237.062 116.067C237.062 112.083 234.84 109.625 230.136 108.537L229.811 108.465L229.012 108.295V66.7124H231.034Z",
  fill: "#C6D7EE"
});

var _ref34 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 230.086,
  cy: 95.3929,
  rx: 8.09023,
  ry: 8.05066,
  fill: "#C6D7EE"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.773 69.7993C327.773 67.5902 329.564 65.7993 331.773 65.7993H386.538C388.747 65.7993 390.538 67.5902 390.538 69.7993V100.469C390.538 102.678 388.747 104.469 386.538 104.469H348.499C347.43 104.469 346.405 104.041 345.654 103.28L328.928 86.3572C328.188 85.6084 327.773 84.5982 327.773 83.5454V69.7993ZM340.934 72.9226H359.156V84.1163H340.934V72.9226ZM383.452 72.9226H365.23V84.1163H383.452V72.9226Z",
  fill: "#C6D7EE"
});

var _ref36 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M114.021 311.612H59.4401L54.7618 330.297H118.699L114.021 311.612Z",
  fill: "#D2E1F7"
}), /*#__PURE__*/React.createElement("rect", {
  width: 46.7837,
  height: 8.56412,
  rx: 1,
  transform: "matrix(-1 0 0 1 110.122 303.047)",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.1838 76.7095L75.7717 88.1045V303.048H77.3311L77.3316 88.7498L87.1843 78.912L97.0369 88.7498L97.0365 303.048H98.5959V88.1045L87.1838 76.7095Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.2263 291.369C77.7591 291.369 77.3143 291.572 77.0045 291.925C76.4382 292.572 76.4645 293.542 77.0426 294.156L77.1441 294.255L96.2895 311.404C96.6269 311.706 97.1427 311.675 97.4415 311.334C97.7174 311.019 97.712 310.55 97.4441 310.242L97.3717 310.169L78.2263 293.02H96.8306C97.2813 293.02 97.6467 292.65 97.6467 292.194C97.6467 291.771 97.3317 291.422 96.9258 291.375L96.8306 291.369H78.2263Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.2263 272.684C77.7591 272.684 77.3143 272.886 77.0045 273.24C76.4382 273.886 76.4645 274.856 77.0426 275.471L77.1441 275.57L96.2895 292.719C96.6269 293.021 97.1427 292.989 97.4415 292.648C97.7174 292.333 97.712 291.864 97.4441 291.556L97.3717 291.483L78.2263 274.334H96.8306C97.2813 274.334 97.6467 273.965 97.6467 273.509C97.6467 273.086 97.3317 272.737 96.9258 272.689L96.8306 272.684H78.2263Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.2263 253.998C77.7591 253.998 77.3143 254.201 77.0045 254.554C76.4382 255.201 76.4645 256.171 77.0426 256.785L77.1441 256.884L96.2895 274.033C96.6269 274.335 97.1427 274.304 97.4415 273.963C97.7174 273.648 97.712 273.179 97.4441 272.871L97.3717 272.798L78.2263 255.649H96.8306C97.2813 255.649 97.6467 255.279 97.6467 254.824C97.6467 254.4 97.3317 254.052 96.9258 254.004L96.8306 253.998H78.2263Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.2263 236.092C77.7591 236.092 77.3143 236.294 77.0045 236.648C76.4382 237.294 76.4645 238.264 77.0426 238.879L77.1441 238.978L96.2895 256.127C96.6269 256.429 97.1427 256.397 97.4415 256.056C97.7174 255.741 97.712 255.272 97.4441 254.964L97.3717 254.891L78.2263 237.742H96.8306C97.2813 237.742 97.6467 237.373 97.6467 236.917C97.6467 236.494 97.3317 236.145 96.9258 236.097L96.8306 236.092H78.2263Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.2263 217.406C77.7591 217.406 77.3143 217.609 77.0045 217.962C76.4382 218.609 76.4645 219.579 77.0426 220.193L77.1441 220.292L96.2895 237.441C96.6269 237.743 97.1427 237.712 97.4415 237.371C97.7174 237.056 97.712 236.587 97.4441 236.279L97.3717 236.206L78.2263 219.057H96.8306C97.2813 219.057 97.6467 218.687 97.6467 218.232C97.6467 217.808 97.3317 217.459 96.9258 217.412L96.8306 217.406H78.2263Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.2263 198.721C77.7591 198.721 77.3143 198.923 77.0045 199.277C76.4382 199.923 76.4645 200.894 77.0426 201.508L77.1441 201.607L96.2895 218.756C96.6269 219.058 97.1427 219.026 97.4415 218.685C97.7174 218.37 97.712 217.901 97.4441 217.594L97.3717 217.52L78.2263 200.371H96.8306C97.2813 200.371 97.6467 200.002 97.6467 199.546C97.6467 199.123 97.3317 198.774 96.9258 198.726L96.8306 198.721H78.2263Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.2263 180.035C77.7591 180.035 77.3143 180.238 77.0045 180.592C76.4382 181.238 76.4645 182.208 77.0426 182.823L77.1441 182.922L96.2895 200.07C96.6269 200.373 97.1427 200.341 97.4415 200C97.7174 199.685 97.712 199.216 97.4441 198.908L97.3717 198.835L78.2263 181.686H96.8306C97.2813 181.686 97.6467 181.316 97.6467 180.861C97.6467 180.437 97.3317 180.089 96.9258 180.041L96.8306 180.035H78.2263Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.2263 161.35C77.7591 161.35 77.3143 161.553 77.0045 161.906C76.4382 162.553 76.4645 163.523 77.0426 164.137L77.1441 164.236L96.2895 181.385C96.6269 181.687 97.1427 181.656 97.4415 181.314C97.7174 181 97.712 180.531 97.4441 180.223L97.3717 180.149L78.2263 163.001H96.8306C97.2813 163.001 97.6467 162.631 97.6467 162.175C97.6467 161.752 97.3317 161.403 96.9258 161.356L96.8306 161.35H78.2263Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.2263 142.665C77.7591 142.665 77.3143 142.867 77.0045 143.221C76.4382 143.867 76.4645 144.838 77.0426 145.452L77.1441 145.551L96.2895 162.7C96.6269 163.002 97.1427 162.97 97.4415 162.629C97.7174 162.314 97.712 161.846 97.4441 161.538L97.3717 161.464L78.2263 144.315H96.8306C97.2813 144.315 97.6467 143.946 97.6467 143.49C97.6467 143.067 97.3317 142.718 96.9258 142.67L96.8306 142.665H78.2263Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.2263 124.758C77.7591 124.758 77.3143 124.961 77.0045 125.314C76.4382 125.961 76.4645 126.931 77.0426 127.545L77.1441 127.644L96.2895 144.793C96.6269 145.095 97.1427 145.064 97.4415 144.722C97.7174 144.407 97.712 143.939 97.4441 143.631L97.3717 143.557L78.2263 126.409H96.8306C97.2813 126.409 97.6467 126.039 97.6467 125.583C97.6467 125.16 97.3317 124.811 96.9258 124.764L96.8306 124.758H78.2263Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.2263 106.073C77.7591 106.073 77.3143 106.275 77.0045 106.629C76.4382 107.275 76.4645 108.246 77.0426 108.86L77.1441 108.959L96.2895 126.108C96.6269 126.41 97.1427 126.378 97.4415 126.037C97.7174 125.722 97.712 125.254 97.4441 124.946L97.3717 124.872L78.2263 107.723H96.8306C97.2813 107.723 97.6467 107.354 97.6467 106.898C97.6467 106.475 97.3317 106.126 96.9258 106.078L96.8306 106.073H78.2263Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.2263 87.3872C77.7591 87.3872 77.3143 87.5897 77.0045 87.9434C76.4382 88.5898 76.4645 89.5601 77.0426 90.1744L77.1441 90.2734L96.2895 107.422C96.6269 107.724 97.1427 107.693 97.4415 107.352C97.7174 107.037 97.712 106.568 97.4441 106.26L97.3717 106.187L78.2263 89.0378H96.8306C97.2813 89.0378 97.6467 88.6683 97.6467 88.2125C97.6467 87.7893 97.3317 87.4404 96.9258 87.3928L96.8306 87.3872H78.2263Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.771 107.672L87.0253 75.8535L36.4191 106.967L37.2368 108.293L87.2163 77.565L179.265 109.145L179.771 107.672Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.0412 106.789C55.573 106.789 55.1272 106.967 54.8167 107.278C54.2492 107.846 54.2755 108.698 54.8549 109.238L54.9566 109.325L74.1442 124.394C74.4823 124.66 74.9992 124.632 75.2987 124.332C75.5752 124.056 75.5698 123.644 75.3014 123.373L75.2288 123.309L56.0412 108.239H74.6865C75.1382 108.239 75.5044 107.915 75.5044 107.514C75.5044 107.142 75.1886 106.836 74.7819 106.794L74.6865 106.789H56.0412Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.5054 106.789C36.0371 106.789 35.5913 106.967 35.2808 107.278C34.7133 107.846 34.7397 108.698 35.319 109.238L35.4207 109.325L54.6083 124.394C54.9464 124.66 55.4633 124.632 55.7628 124.332C56.0393 124.056 56.0339 123.644 55.7655 123.373L55.6929 123.309L36.5054 108.239H55.1506C55.6023 108.239 55.9685 107.915 55.9685 107.514C55.9685 107.142 55.6527 106.836 55.246 106.794L55.1506 106.789H36.5054Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.8693 126.123V106.789H56.7498V126.123H34.8693ZM55.1869 108.336H36.4322V124.577H55.1869V108.336Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.1869 126.123V106.789H77.0674V126.123H55.1869ZM75.5045 108.336H56.7498V124.577H75.5045V108.336Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.775 106.789C117.307 106.789 116.861 106.967 116.551 107.278C115.983 107.846 116.01 108.698 116.589 109.238L116.691 109.325L135.878 124.394C136.216 124.66 136.733 124.632 137.033 124.332C137.309 124.056 137.304 123.644 137.036 123.373L136.963 123.309L117.775 108.239H136.421C136.872 108.239 137.239 107.915 137.239 107.514C137.239 107.142 136.923 106.836 136.516 106.794L136.421 106.789H117.775Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.2395 106.789C97.7712 106.789 97.3254 106.967 97.0149 107.278C96.4474 107.846 96.4738 108.698 97.0532 109.238L97.1548 109.325L116.342 124.394C116.681 124.66 117.197 124.632 117.497 124.332C117.773 124.056 117.768 123.644 117.5 123.373L117.427 123.309L98.2395 108.239H116.885C117.336 108.239 117.703 107.915 117.703 107.514C117.703 107.142 117.387 106.836 116.98 106.794L116.885 106.789H98.2395Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M96.6034 126.123V106.789H118.484V126.123H96.6034ZM116.921 108.336H98.1663V124.577H116.921V108.336Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M116.921 126.123V106.789H138.802V126.123H116.921ZM137.239 108.336H118.484V124.577H137.239V108.336Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.411 106.789C157.942 106.789 157.497 106.967 157.186 107.278C156.619 107.846 156.645 108.698 157.224 109.238L157.326 109.325L176.514 124.394C176.852 124.66 177.369 124.632 177.668 124.332C177.945 124.056 177.939 123.644 177.671 123.373L177.598 123.309L158.411 108.239H177.056C177.508 108.239 177.874 107.915 177.874 107.514C177.874 107.142 177.558 106.836 177.151 106.794L177.056 106.789H158.411Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.874 106.789C138.406 106.789 137.96 106.967 137.65 107.278C137.082 107.846 137.109 108.698 137.688 109.238L137.79 109.325L156.977 124.394C157.316 124.66 157.832 124.632 158.132 124.332C158.408 124.056 158.403 123.644 158.135 123.373L158.062 123.309L138.874 108.239H157.52C157.971 108.239 158.338 107.915 158.338 107.514C158.338 107.142 158.022 106.836 157.615 106.794L157.52 106.789H138.874Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M137.239 126.123V106.789H159.119V126.123H137.239ZM157.556 108.336H138.802V124.577H157.556V108.336Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M157.556 126.123V106.789H179.437V126.123H157.556ZM177.874 108.336H159.119V124.577H177.874V108.336Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.728 106.789C178.26 106.789 177.814 106.967 177.504 107.278C176.936 107.846 176.963 108.698 177.542 109.238L177.644 109.325L196.831 124.394C197.169 124.66 197.686 124.632 197.986 124.332C198.262 124.056 198.257 123.644 197.988 123.373L197.916 123.309L178.728 108.239H197.373C197.825 108.239 198.191 107.915 198.191 107.514C198.191 107.142 197.876 106.836 197.469 106.794L197.373 106.789H178.728Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M217.655 126.124C218.123 126.124 218.569 125.946 218.879 125.635C219.447 125.067 219.42 124.214 218.841 123.674L218.739 123.587L199.552 108.518C199.214 108.252 198.697 108.28 198.397 108.58C198.121 108.857 198.126 109.269 198.394 109.539L198.467 109.604L217.655 124.673H199.009C198.558 124.673 198.191 124.998 198.191 125.398C198.191 125.77 198.507 126.077 198.914 126.119L199.009 126.124H217.655Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M177.874 126.123V106.789H199.754V126.123H177.874ZM198.191 108.336H179.437V124.577H198.191V108.336Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M198.24 126.51L198.241 157.23L198.073 157.273C194.182 158.317 192.109 160.662 192.022 164.207L192.019 164.44C192.019 168.387 194.163 170.509 198.224 170.548C202.639 170.367 205.044 168.352 205.131 164.651L205.134 164.44H203.571C203.571 167.381 201.874 168.85 198.199 169.002C195.032 168.97 193.582 167.535 193.582 164.44C193.582 161.378 195.299 159.489 198.934 158.653L199.185 158.598L199.803 158.467V126.51H198.24Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.25155,
  ry: 6.18707,
  transform: "matrix(-1 0 0 1 198.973 148.552)",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M123.98 126.124H75.1629V156.286H109.16L123.98 141.247V126.124ZM113.744 131.68H99.5716V140.411H113.744V131.68ZM80.6746 131.68H94.8473V140.411H80.6746V131.68Z",
  fill: "#C6D7EE"
}));

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M242.537 324.883H186.746L188.637 300.135H240.646L242.537 324.883V324.883Z",
  fill: "#DFEAF8"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M242.537 324.883H186.746L188.637 300.135H240.646L242.537 324.883V324.883Z",
  fill: "white"
});

var _ref39 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_823:50874)"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#filter0_f_823:50874)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M102.586 282.228V303.646C102.586 305.16 103.184 306.613 104.248 307.684C105.312 308.755 106.755 309.357 108.26 309.357H321.495C324.628 309.357 327.168 306.8 327.168 303.646V303.646V282.228H102.586Z",
  fill: "#ABADBE"
})));

var _ref40 = /*#__PURE__*/React.createElement("rect", {
  x: 184.421,
  y: 321.79,
  width: 61.9902,
  height: 5.4137,
  fill: "#DFEAF8"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M321.341 143.138H108.716C105.592 143.138 103.059 145.657 103.059 148.765L-nan -nanL-nan -nanL103.059 148.765V273.707C103.059 275.916 104.85 277.707 107.059 277.707H322.998C325.208 277.707 326.998 275.916 326.998 273.707V148.765C326.998 147.272 326.402 145.841 325.341 144.786C324.28 143.731 322.842 143.138 321.341 143.138L321.341 143.138Z",
  fill: "#C6D7EE"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M103.059 277.707V299.077C103.059 300.588 103.655 302.037 104.716 303.106C105.777 304.175 107.216 304.775 108.716 304.775H321.341C324.466 304.775 326.998 302.224 326.998 299.077V299.077V277.707H103.059Z",
  fill: "#DFEAF8"
});

var _ref43 = /*#__PURE__*/React.createElement("rect", {
  x: 114.682,
  y: 154.739,
  width: 201.468,
  height: 112.914,
  fill: "white"
});

var _ref44 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 215.804,
  cy: 290.468,
  rx: 5.81158,
  ry: 5.80037,
  fill: "#C6D7EE"
});

var _ref45 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 121.269,
  cy: 158.219,
  rx: 1.16232,
  ry: 1.16008,
  fill: "#C6D7EE"
});

var _ref46 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 125.143,
  cy: 158.219,
  rx: 1.16232,
  ry: 1.16008,
  fill: "#C6D7EE"
});

var _ref47 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 129.017,
  cy: 158.219,
  rx: 1.16232,
  ry: 1.16008,
  fill: "#C6D7EE"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M131.729 176.394L171.993 176.431L172.023 211.196L131.759 211.159L131.729 176.394Z",
  fill: "#E1E8F3"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M141.518 193.406L148.357 202.653L134.695 202.641L141.518 193.406Z",
  fill: "#C6D0DF"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M156.527 189.343L168.291 205.117L144.792 205.096L156.527 189.343Z",
  fill: "white"
});

var _ref51 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 141.515,
  cy: 189.321,
  rx: 4.37418,
  ry: 4.34639,
  fill: "#D2E1F7"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M258.034 176.394L298.299 176.431L298.328 211.196L258.064 211.159L258.034 176.394Z",
  fill: "#E1E8F3"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M267.823 193.406L274.662 202.653L261 202.641L267.823 193.406Z",
  fill: "#C6D0DF"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M282.833 189.343L294.596 205.117L271.097 205.096L282.833 189.343Z",
  fill: "white"
});

var _ref55 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 267.82,
  cy: 189.321,
  rx: 4.37416,
  ry: 4.34639,
  fill: "#D2E1F7"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M195.269 176.394L235.533 176.431L235.563 211.196L195.299 211.159L195.269 176.394Z",
  fill: "#E1E8F3"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M205.058 193.406L211.897 202.653L198.235 202.641L205.058 193.406Z",
  fill: "#C6D0DF"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M220.067 189.343L231.831 205.117L208.332 205.096L220.067 189.343Z",
  fill: "white"
});

var _ref59 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 205.055,
  cy: 189.321,
  rx: 4.37418,
  ry: 4.34639,
  fill: "#D2E1F7"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M133.111 228.21C132.348 228.212 131.729 228.904 131.729 229.757C131.729 230.61 132.348 231.302 133.111 231.304H169.866C170.63 231.302 171.248 230.61 171.248 229.757C171.248 228.904 170.63 228.212 169.866 228.21H133.111Z",
  fill: "#D2E1F7"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M133.116 235.171C132.35 235.172 131.729 235.864 131.729 236.717C131.729 237.571 132.35 238.263 133.116 238.264H149.715C150.481 238.263 151.101 237.571 151.101 236.717C151.101 235.864 150.481 235.172 149.715 235.171H133.116Z",
  fill: "#C6D7EE"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M197.426 228.21C196.663 228.212 196.044 228.904 196.044 229.757C196.044 230.61 196.663 231.302 197.426 231.304H234.181C234.945 231.302 235.563 230.61 235.563 229.757C235.563 228.904 234.945 228.212 234.181 228.21H197.426Z",
  fill: "#D2E1F7"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M197.43 235.171C196.664 235.172 196.044 235.864 196.044 236.717C196.044 237.571 196.664 238.263 197.43 238.264H214.03C214.796 238.263 215.416 237.571 215.416 236.717C215.416 235.864 214.796 235.172 214.03 235.171H197.43Z",
  fill: "#C6D7EE"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M259.416 228.21C258.653 228.212 258.034 228.904 258.034 229.757C258.034 230.61 258.653 231.302 259.416 231.304H296.171C296.935 231.302 297.553 230.61 297.553 229.757C297.553 228.904 296.935 228.212 296.171 228.21H259.416Z",
  fill: "#D2E1F7"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M133.111 221.25C132.348 221.251 131.729 221.943 131.729 222.797C131.729 223.65 132.348 224.342 133.111 224.343H169.866C170.63 224.342 171.248 223.65 171.248 222.797C171.248 221.943 170.63 221.251 169.866 221.25H133.111Z",
  fill: "#D2E1F7"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M197.426 221.25C196.663 221.251 196.044 221.943 196.044 222.797C196.044 223.65 196.663 224.342 197.426 224.343H234.181C234.945 224.342 235.563 223.65 235.563 222.797C235.563 221.943 234.945 221.251 234.181 221.25H197.426Z",
  fill: "#D2E1F7"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M259.416 221.25C258.653 221.251 258.034 221.943 258.034 222.797C258.034 223.65 258.653 224.342 259.416 224.343H296.171C296.935 224.342 297.553 223.65 297.553 222.797C297.553 221.943 296.935 221.251 296.171 221.25H259.416Z",
  fill: "#D2E1F7"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M259.421 235.171C258.655 235.172 258.034 235.864 258.034 236.717C258.034 237.571 258.655 238.263 259.421 238.264H276.02C276.786 238.263 277.406 237.571 277.406 236.717C277.406 235.864 276.786 235.172 276.02 235.171H259.421Z",
  fill: "#C6D7EE"
});

var _ref69 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#filter1_f_823:50874)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M184.978 117.638L298.266 182.919L261.538 246.412L148.249 181.131L184.978 117.638Z",
  fill: "#C6D7EE"
}));

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M288.668 180.14C288.668 180.14 273.29 164.989 257.839 149.607C241.098 132.942 190.968 122.708 190.968 122.708V122.708",
  stroke: "#C6D7EE",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M184.978 117.638L298.266 182.919L261.538 246.412L148.249 181.131L184.978 117.638Z",
  fill: "white"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M194.319 133.484L280.517 183.154L252.571 231.464L166.374 181.794L194.319 133.484Z",
  fill: "#DFEAF8"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M225.91 198.215C225.91 198.215 218.827 200.103 212.834 197.049C206.84 193.995 204.204 187.155 204.204 187.155",
  stroke: "#C6D7EE",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M232.924 186.09L232.236 185.805C231.963 185.689 231.642 185.8 231.49 186.063L231.04 186.841C230.887 187.104 230.952 187.437 231.19 187.616L231.78 188.067C231.737 188.263 231.709 188.46 231.698 188.656L231.002 188.947C230.721 189.065 230.568 189.373 230.647 189.662L230.866 190.518C230.935 190.806 231.215 190.993 231.515 190.948L232.257 190.838C232.361 191.001 232.479 191.157 232.61 191.305L232.314 192.005C232.193 192.283 232.297 192.605 232.554 192.753L233.317 193.193C233.574 193.341 233.906 193.269 234.088 193.025L234.547 192.42C234.74 192.46 234.935 192.484 235.129 192.491L235.404 193.188C235.515 193.469 235.817 193.618 236.104 193.533L236.957 193.295C237.244 193.219 237.435 192.933 237.396 192.631L237.302 191.884C237.465 191.776 237.623 191.654 237.771 191.518L238.459 191.804C238.733 191.919 239.054 191.809 239.206 191.546L239.656 190.767C239.809 190.504 239.744 190.171 239.506 189.992L238.915 189.541C238.958 189.345 238.986 189.148 238.998 188.953L239.693 188.661C239.975 188.543 240.128 188.235 240.049 187.946L239.83 187.091C239.76 186.802 239.481 186.616 239.181 186.66L238.439 186.771C238.335 186.607 238.217 186.451 238.085 186.304L238.382 185.604C238.502 185.325 238.399 185.003 238.141 184.855L237.379 184.416C237.121 184.267 236.79 184.339 236.608 184.583L236.149 185.188C235.955 185.148 235.76 185.124 235.567 185.116L235.292 184.42C235.18 184.139 234.879 183.99 234.591 184.075L233.739 184.314C233.451 184.389 233.261 184.675 233.299 184.977L233.394 185.724C233.23 185.832 233.073 185.955 232.924 186.09ZM237.049 189.784C236.495 190.742 235.281 191.082 234.343 190.541C233.405 190.001 233.092 188.782 233.646 187.824C234.201 186.866 235.415 186.527 236.353 187.067C237.291 187.608 237.603 188.826 237.049 189.784Z",
  fill: "#C6D7EE"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M248.301 187.933L241.97 176.744L239.61 178.134L245.94 189.323L248.301 187.933Z",
  fill: "#C6D7EE"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.298 172.46L209.889 172.911C210.127 173.09 210.191 173.423 210.039 173.685L209.588 174.464C209.436 174.727 209.115 174.837 208.84 174.721L208.154 174.436C208.006 174.572 207.848 174.694 207.684 174.802L207.779 175.549C207.817 175.851 207.627 176.137 207.337 176.214L206.484 176.452C206.199 176.537 205.898 176.388 205.786 176.106L205.511 175.41C205.317 175.402 205.122 175.378 204.929 175.338L204.47 175.945C204.288 176.187 203.957 176.259 203.699 176.111L202.937 175.672C202.679 175.523 202.576 175.201 202.697 174.921L202.993 174.222C202.861 174.075 202.743 173.919 202.64 173.755L201.898 173.866C201.597 173.91 201.318 173.724 201.248 173.433L201.028 172.577C200.95 172.291 201.103 171.984 201.385 171.866L202.08 171.574C202.092 171.378 202.12 171.181 202.163 170.985L201.571 170.533C201.334 170.355 201.27 170.022 201.422 169.759L201.872 168.981C202.024 168.718 202.346 168.607 202.62 168.723L203.307 169.008C203.455 168.873 203.612 168.75 203.776 168.642L203.682 167.896C203.644 167.593 203.834 167.307 204.124 167.231L204.977 166.993C205.262 166.908 205.563 167.057 205.674 167.338L205.949 168.034C206.143 168.042 206.338 168.067 206.532 168.106L206.991 167.5C207.172 167.257 207.504 167.185 207.761 167.334L208.524 167.773C208.781 167.921 208.885 168.244 208.764 168.523L208.468 169.222C208.599 169.369 208.718 169.526 208.821 169.689L209.563 169.578C209.863 169.534 210.143 169.72 210.213 170.012L210.432 170.868C210.51 171.153 210.357 171.461 210.076 171.579L209.38 171.871C209.368 172.066 209.341 172.264 209.298 172.46ZM204.029 170.742C203.475 171.7 203.787 172.919 204.725 173.459C205.663 174 206.878 173.66 207.432 172.702C207.986 171.745 207.674 170.526 206.735 169.985C205.797 169.445 204.583 169.784 204.029 170.742Z",
  fill: "#C6D7EE"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M200.01 160.091L212.883 159.968L212.857 162.703L199.984 162.826L200.01 160.091Z",
  fill: "#C6D7EE"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M341.097 321.79C342.297 321.79 343.271 322.829 343.271 324.11C343.271 325.316 342.409 326.307 341.306 326.419L341.097 326.43H295.853C294.652 326.43 293.679 325.391 293.679 324.11C293.679 322.904 294.541 321.913 295.644 321.8L295.853 321.79H341.097Z",
  fill: "#E2E8F2"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M299.103 321.79H337.072L332.264 310.189H303.462L299.103 321.79Z",
  fill: "url(#paint0_linear_823:50874)"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M306.077 300.908H329.323L326.379 289.308H308.745L306.077 300.908Z",
  fill: "url(#paint1_linear_823:50874)"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.752 310.189H332.423L328.792 300.135H307.044L303.752 310.189Z",
  fill: "#E2E8F2"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M308.401 289.308H328.548L317.859 279.254L308.401 289.308Z",
  fill: "#E2E8F2"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M159.279 324.11C159.898 324.11 160.4 324.629 160.4 325.27C160.4 325.873 159.955 326.368 159.386 326.425L159.279 326.43H135.95C135.331 326.43 134.829 325.911 134.829 325.27C134.829 324.667 135.273 324.171 135.842 324.115L135.95 324.11H159.279Z",
  fill: "#E2E8F2"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M137.928 324.11H157.3L154.847 317.923H140.152L137.928 324.11Z",
  fill: "url(#paint2_linear_823:50874)"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M141.802 313.283H153.426L151.954 307.095H143.137L141.802 313.283Z",
  fill: "url(#paint3_linear_823:50874)"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M140.253 318.696H154.975L153.111 313.282H141.943L140.253 318.696Z",
  fill: "#E2E8F2"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M142.577 307.869H152.651L147.306 302.455L142.577 307.869Z",
  fill: "#E2E8F2"
});

var _ref88 = /*#__PURE__*/React.createElement("rect", {
  x: 10.0735,
  y: 326.817,
  width: 430.138,
  height: 3.86694,
  rx: 1.93347,
  fill: "#C6D7EE"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4609 267.653C11.9587 267.653 13.1729 268.867 13.1729 270.365V323.718C13.1729 325.216 11.9587 326.43 10.4609 326.43V326.43C8.96302 326.43 7.74878 325.216 7.74878 323.718V270.365C7.74878 268.867 8.96302 267.653 10.4609 267.653V267.653Z",
  fill: "#C6D7EE"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M63.1525 267.653C64.6503 267.653 65.8646 268.867 65.8646 270.365V323.718C65.8646 325.216 64.6503 326.43 63.1525 326.43V326.43C61.6547 326.43 60.4404 325.216 60.4404 323.718V270.365C60.4404 268.867 61.6547 267.653 63.1525 267.653V267.653Z",
  fill: "#C6D7EE"
});

var _ref91 = /*#__PURE__*/React.createElement("rect", {
  y: 269.2,
  width: 77.4878,
  height: 25.5217,
  fill: "#E2E8F2"
});

var _ref92 = /*#__PURE__*/React.createElement("rect", {
  y: 269.2,
  width: 77.4878,
  height: 25.5217,
  fill: "white"
});

var _ref93 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_823:50874)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.54886 268.426L15.4975 270.803L5.17377 296.268L-0.774902 293.891L9.54886 268.426Z",
  fill: "url(#paint4_linear_823:50874)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.0203 268.426L37.969 270.803L27.6452 296.268L21.6965 293.891L32.0203 268.426Z",
  fill: "url(#paint5_linear_823:50874)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.7168 268.426L59.6655 270.803L49.3417 296.268L43.3931 293.891L53.7168 268.426Z",
  fill: "url(#paint6_linear_823:50874)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75.4136 268.426L81.3623 270.803L71.0385 296.268L65.0898 293.891L75.4136 268.426Z",
  fill: "url(#paint7_linear_823:50874)"
}));

var _ref94 = /*#__PURE__*/React.createElement("rect", {
  x: 89.1108,
  y: 342.284,
  width: 183.004,
  height: 3.86691,
  rx: 1.93346,
  fill: "#C6D7EE"
});

var _ref95 = /*#__PURE__*/React.createElement("rect", {
  x: 301.523,
  y: 340.436,
  width: 59.5698,
  height: 5.04123,
  rx: 2.52061,
  fill: "#C6D7EE"
});

var _ref96 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_823:50874",
  x: 75.4036,
  y: 255.045,
  width: 278.948,
  height: 81.4943,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 13.5914,
  result: "effect1_foregroundBlur_823:50874"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_823:50874",
  x: 121.066,
  y: 90.4551,
  width: 204.382,
  height: 183.14,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 13.5914,
  result: "effect1_foregroundBlur_823:50874"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_823:50874",
  x1: 340.428,
  y1: 322.699,
  x2: 337.836,
  y2: 302.919,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9E4F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C5D3F5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_823:50874",
  x1: 331.378,
  y1: 301.817,
  x2: 327.26,
  y2: 282.579,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9E4F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C5D3F5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_823:50874",
  x1: 159.012,
  y1: 324.595,
  x2: 157.57,
  y2: 314.062,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9E4F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C5D3F5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_823:50874",
  x1: 154.453,
  y1: 313.767,
  x2: 152.125,
  y2: 303.569,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9E4F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C5D3F5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_823:50874",
  x1: 16.9359,
  y1: 298.45,
  x2: -6.09567,
  y2: 267.064,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9E4F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C5D3F5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_823:50874",
  x1: 39.4073,
  y1: 298.45,
  x2: 16.3758,
  y2: 267.064,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9E4F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C5D3F5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_823:50874",
  x1: 61.1038,
  y1: 298.45,
  x2: 38.0723,
  y2: 267.064,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9E4F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C5D3F5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_823:50874",
  x1: 82.8006,
  y1: 298.45,
  x2: 59.7691,
  y2: 267.064,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9E4F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C5D3F5"
})));

function SvgBlankPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 443,
    height: 347,
    viewBox: "0 0 443 347",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_823:50874",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 300,
    width: 57,
    height: 25
  }, _ref38), _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_823:50874",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 269,
    width: 78,
    height: 26
  }, _ref92), _ref93, _ref94, _ref95, _ref96);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankPage);
export default __webpack_public_path__ + "static/media/blank-page.b7c7a52a.svg";
export { ForwardRef as ReactComponent };